module.exports = __webpack_public_path__ + "files/ba8d9c3ceeb048c4bde9665996ff4df7.png";